import { render } from "./ArticleCardSkeleton.vue?vue&type=template&id=18d12bb2&ts=true"
import script from "./ArticleCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./ArticleCardSkeleton.vue?vue&type=script&lang=ts"

import "./ArticleCardSkeleton.vue?vue&type=style&index=0&id=18d12bb2&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__